/// <amd-module name="Feed/Admin/Redux/GlobalSettings/GlobalSettingsContracts" />
import { IGlobalPermissionData } from "Feed/Admin/Types";

export interface IGlobalSettingsAwareState {
    globalSettingsState: IGlobalSettingsState;
}

export interface IGlobalSettingsState extends IGlobalPermissionData {
    errorMessage: string | undefined;
    isLoading: boolean;
    isSaving: boolean;
}
